import {JobState} from "../../libs/enum/job-state.enum";
import {isDefined} from "../../libs/utils/epic.utils";

export class ExportStatusDto {

  public readonly state!: JobState;
  public readonly completed: Date | undefined;
  public readonly accVersion!: string;
  public readonly mediaId: string | undefined;
  public readonly filename: string | undefined;
  public readonly created!: Date;

  constructor(init?: Partial<ExportStatusDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.completed)) {
      this.completed = new Date(init.completed);
    }
    if (isDefined(init?.created)) {
      this.created = new Date(init.created);
    }
  }
}
